import { EventEmitter, Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { JwtHelper, tokenNotExpired } from 'angular2-jwt';
import { AppError } from 'app/common/app-error';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
//import { DebuggingService } from "app/services/debugging/debugging.service";
import { ActivatedRoute, Router } from '@angular/router';
import { BadInput } from 'app/common/bad-input';
import { NoTokenError } from 'app/common/no-token-error';
import { NotFoundError } from 'app/common/not-found-error';
import { User } from 'domain-models/User';
import { UserCredentials } from 'domain-models/UserCredentials';
import { ConfirmationService } from 'primeng/primeng';
import { Subscription } from 'rxjs/Subscription';
import { UserIdleService } from 'services/user-idle/user-idle.service';
import { environment } from '../../environments/environment';

@Injectable()
/**
 * AuthService allows to handle the authentication with the server while handiling:
 *  -Token requests
 *  -Letting you know if an user is logged in
 *  -If a token should be renew
 */
export class AuthService {
	/** url to where the request is going to be made  */
	url: string = environment.host;
	readAccess: boolean;
	writeAccess: boolean;
	currentUser: User;
	refresher: Subscription;
	onLogStatusChanged: EventEmitter<any> = new EventEmitter<any>();

	/**Debugging varible, allows to print only if debugging mode */
	//private debug = new DebuggingService(AuthService.name);

	IsLoggedIn() {
		let token = localStorage.getItem('readToken');
		// if (!token)
		//   return false;
		let headers = new Headers();
		/** Header that represents the token */
		headers.append('x-access-token', token);
		let options = new RequestOptions({ headers: headers });

		/** Make the request */
		this.http
			.get(this.url + 'Authenticate/validate', options)
			.map((response) => {
				let result = response.json();
				if (result && result.success == true) {
					return true;
				}
				return false;
			})
			.subscribe((res) => {
				if (res == true) {
					this.getCurrentUser();
					let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
					this.router.navigate([returnUrl || '/']);
				} else {
					localStorage.removeItem('token');
					localStorage.removeItem('readToken');
					localStorage.removeItem('reftoken');
					this.currentUser = new User();
					this.readAccess = false;
					this.writeAccess = false;
				}
			});
	}

	constructor(
		private http: Http,
		private router: Router,
		private route: ActivatedRoute,
		public userIdleService: UserIdleService,
		private confirmationService: ConfirmationService
	) {}

	/**
	 * Allows to make a call to the server to renew a token based on the refreshToken.
	 * Make sure to tall shouldRefresh to validate if you should or should not refresh the token
	 */
	RefreshToken(): Subscription {
		/**Variable that represents the token read from memory */
		let token: string = localStorage.getItem('reftoken');

		//if(isDevMode())console.log("refreshing...");

		//console.log("Refreshing...");

		/**Variable representing the headers */
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		/** Header that represents the token */
		headers.append('x-refresh-token', token);
		let options = new RequestOptions({ headers: headers });

		/** Make the request */
		this.refresher = this.http
			.get(this.url + 'Authenticate/refresh', options)
			.subscribe((response) => {
				/** Print new token for DEBUGING */
				//console.log(response.json());

				let result = response.json();
				if (result && result.token && result.refreshToken && result.readToken) {
					localStorage.setItem('token', result.token);
					localStorage.setItem('readToken', result.readToken);
					localStorage.setItem('reftoken', result.refreshToken);
					this.getCurrentUser();
					this.writeAccess = true;
					this.readAccess = true;
					return true;
				}
				this.logout();
				return false;
			});
		return this.refresher;
	}
	/**
	 * Function that return a boolean letting you know if it is fine to update a token or not
	 */
	shouldRefresh(): boolean {
		if (!this.currentUser) return false;
		let token = localStorage.getItem('reftoken');
		if (!token) return false;
		let jwtHelper = new JwtHelper();
		let isExpired = jwtHelper.isTokenExpired(token);
		if (isExpired == true) {
			this.logout();
			return false;
		}

		return true;
	}

	ssoLogin(ssoToken: string, tokenb?: string): Promise<any> {
		return new Promise((resolve, reject) => {
			console.log(this.url + 'Authenticate/sso-login');
			var headers = new Headers();
			headers.append('Content-Type', 'application/json');
			if (!tokenb) {
				tokenb = localStorage.getItem('tokenB') ? localStorage.getItem('tokenB') : 'notoken';
			}
			return this.http
				.post(
					this.url + 'Authenticate/sso-login',
					JSON.stringify({ access_token: ssoToken, tokenb: tokenb }),
					{ headers: headers }
				)
				.map((res) => {
					// console.log("login", response.json());
					let result = res.json();
					if (result && result.token && result.refreshToken) {
						localStorage.setItem('token', result.token);
						localStorage.setItem('reftoken', result.refreshToken);
						localStorage.setItem('readToken', result.readToken);
						this.getCurrentUser();
						this.writeAccess = true;
						this.readAccess = true;
						// decode token and log if they are admin for testing purposes
						// TODO: REMOVE ONCE WE TEST THIS
						const adminUser = new JwtHelper().decodeToken(result.readToken);
						if (adminUser && adminUser.data) {
							console.log('IS ADMIN: ', adminUser.data.is_admin);
						}
						this.onLogStatusChanged.emit(true);
						return true;
					}
					// resolve(response)
				})
				.catch(this.handleError)
				.subscribe(
					(res) => {
						resolve(res);
					},
					(err) => {
						reject(err);
					}
				);
		});
	}

	/**
	 * Function to perform login of a user.
	 * @param credentials user credentials to be send to the server, must contain username and password
	 */
	login(credentials: UserCredentials, tokenb?: string): Observable<boolean> {
		/**DEBUGGIN */
		console.log('login', 'trying to log in');
		// console.log("login", credentials);

		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		if (!tokenb) {
			tokenb = localStorage.getItem('tokenB') ? localStorage.getItem('tokenB') : 'notoken';
		}
		if (tokenb)
			//TO Do added by Basel
			headers.append('x-browser-token', tokenb);

		return this.http
			.post(this.url + 'Authenticate', JSON.stringify(credentials), { headers: headers })
			.map((response) => {
				console.log('login', response.json());

				let result = response.json();
				if (result && result.token && result.refreshToken) {
					localStorage.setItem('token', result.token);
					localStorage.setItem('reftoken', result.refreshToken);
					localStorage.setItem('readToken', result.readToken);
					this.getCurrentUser();
					this.readAccess = true;
					this.writeAccess = true;
					this.onLogStatusChanged.emit(true);
					return true;
				}
				return false;
			})
			.catch(this.handleError);
	}

	private handleError(error: Response) {
		if (!error.status) {
			return Observable.throw(
				new AppError({
					message:
						'Something may be wrong with the Server. Please try again later or contact an administrator.'
				})
			);
		}
		if (error.status === 403) {
			return Observable.throw(
				new AppError({
					message:
						'Something may be wrong with the Server. Please try again later or contact an administrator.'
				})
			);
		}
		if (error.status === 404) {
			console.log('error 404');
			return Observable.throw(new NotFoundError({ message: 'Not Found Error' }));
		}
		if (error.status === 400) return Observable.throw(new BadInput(error.json()));
		if (error.status === 401) return Observable.throw(new BadInput(error.json()));
		if (error.status === 417) return Observable.throw(new NoTokenError(error.json()));

		return Observable.throw(new AppError(error));
	}

	getSalt(username: string): Observable<any> {
		/**DEBUGGIN */
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		console.log(JSON.stringify(username));
		return this.http
			.post(this.url + 'Authenticate/un', '{ "username": "' + username + '"}', { headers: headers })
			.map((response) => {
				console.log('login', response);

				let result: string = response.json();
				return result;
			})
			.catch(this.handleError);
	}

	/**Void Function to perform the logout of the user */
	logout() {
		this.currentUser = new User();
		this.onLogStatusChanged.emit(false);
		this.readAccess = false;
		this.writeAccess = false;
		if (this.refresher) this.refresher.unsubscribe();
		localStorage.removeItem('token');
		localStorage.removeItem('reftoken');
		localStorage.removeItem('readToken');

		//this.router.navigate(['/login'], {queryParams: {returnUrl:state.url}});
	}

	/**Function to get the current user */
	getCurrentUser() {
		this.currentUser = new User();
		let token = localStorage.getItem('readToken');
		if (!token) return null;
		var decodedToken = new JwtHelper().decodeToken(token);
		this.currentUser.id = decodedToken.data.id;
		this.currentUser.is_admin = decodedToken.data.is_admin;
		this.currentUser.account_type = decodedToken.data.account_type;
		this.currentUser.username = decodedToken.data.username;
		this.currentUser.name = decodedToken.data.name;
		this.currentUser.lastname = decodedToken.data.lastname;
		this.readAccess = true;

		// Make sure we also set writeAccess true if applicable
		let tokenw = localStorage.getItem('token');
		if (tokenw) {
			this.writeAccess = true;
		}

		return true;
		//console.log("Current this.currentUser",decodedToken);
		//console.log("Status",tokenNotExpired());
		//this.currentUser=user;
	}
	sendValidationCodeAsync(credentials) {
		return new Promise((resolve, reject) => {
			var headers = new Headers();
			headers.append('Content-Type', 'application/json');

			this.http
				.post(this.url + 'Authenticate/generateCode', JSON.stringify(credentials), {
					headers: headers
				})
				.map((response) => {
					console.log('Mapping response', response);
					var res = response.json();
					return res.email;
				})
				.catch(this.handleError)
				.subscribe(
					(res) => {
						console.log('Got some reulst');
						resolve(res);
					},
					(err) => {
						console.log('Rejection');
						reject(err);
					}
				);
		});
	}
	sendValidationCode(credentials) {
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this.http
			.post(this.url + 'Authenticate/generateCode', JSON.stringify(credentials), {
				headers: headers
			})
			.map((response) => {
				var res = response.json();
				return res.email;
			})
			.catch(this.handleError);
	}

	getBrowserTokenForSSO(token, totp, trustedBrowser) {
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this.http
			.post(
				this.url + 'Authenticate/validateCodeSSO',
				JSON.stringify({ access_token: token, totp: totp }),
				{ headers: headers }
			)
			.map((response) => {
				var result = response.json();
				if (trustedBrowser === true) localStorage.setItem('tokenB', result.token);
				return result;
			})
			.catch(this.handleError);
	}

	getBrowserToken(credentials, trustedBrowser) {
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this.http
			.post(this.url + 'Authenticate/validateCode', JSON.stringify(credentials), {
				headers: headers
			})
			.map((response) => {
				var result = response.json();
				if (trustedBrowser === true) localStorage.setItem('tokenB', result.token);
				return result;
			})
			.catch(this.handleError);
	}

	/**Function that lets you know if the user has logged in */
	updateLogStatus() {
		// if(!tokenNotExpired() && this.shouldRefresh()){
		//   this.RefreshToken().subscribe(x =>{
		//      console.log("Return from refresh",x);
		//      return tokenNotExpired();
		//     }
		//   );
		// }
		// else

		this.writeAccess = tokenNotExpired('token');
		this.readAccess = tokenNotExpired('readToken');

		// let jwtHelper = new JwtHelper();
		// let token = localStorage.getItem('readToken');
		// if(!token)
		//   return false;
		// let expirationDate = jwtHelper.getTokenExpirationDate(token);
		// let isExpired = jwtHelper.isTokenExpired(token);
		// console.log("Expiration", expirationDate);
		// console.log("isExpired", isExpired);
		// return !isExpired;
	}

	getTokenExpiration(tokenName: 'token' | 'readToken' = 'token') {
		let jwtHelper = new JwtHelper();
		let token = localStorage.getItem(tokenName);
		if (!token) return false;
		let expirationDate = jwtHelper.getTokenExpirationDate(token);
		let isExpired = jwtHelper.isTokenExpired(token);
		if (isExpired) return null;

		return expirationDate;
	}

	checkWriteAccess(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			if (!this.writeAccess) {
				this.confirmationService.confirm({
					key: 'login',
					message: '',
					accept: () => {
						resolve(true);
					},
					reject: () => {
						if (this.userIdleService.readTimeLeft === 'expired') {
							this.logout();
							resolve(false);
						}
					}
				});
			} else {
				resolve(true);
			}
		});
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/auth/auth.service.ts